// Órdenes de compra del comprador: las de videollamada (source 'call') y las
// del carrito (source 'cart', etapa 3).

// La línea de envío (kind 'shipping') no es un producto: no se lista ni se
// cuenta como tal. Las órdenes viejas no traen `kind`.
export const productItems = (purchaseOrder) =>
    ((purchaseOrder && purchaseOrder.items) || []).filter(
        (item) => item.kind !== 'shipping'
    );

const lineTotal = (item) =>
    item.lineTotal !== null && item.lineTotal !== undefined
        ? Number(item.lineTotal)
        : Number(item.unitPrice) * Number(item.quantity);

// El costo de envío es la línea kind 'shipping' (va incluida en `total`).
// Sólo de ahí: en órdenes viejas de videollamada `shippingPrice` puede estar
// cargado sin línea y sin estar sumado al total. null si no hay.
export const shippingCost = (purchaseOrder) => {
    const line = ((purchaseOrder && purchaseOrder.items) || []).find(
        (item) => item.kind === 'shipping'
    );
    return line ? lineTotal(line) : null;
};

export const HOME_DELIVERY_SHIPPING_OPTION_ID = 3;

export const isHomeDelivery = (purchaseOrder) =>
    Boolean(purchaseOrder) &&
    Number(purchaseOrder.shippingOptionId) === HOME_DELIVERY_SHIPPING_OPTION_ID;

// "Córdoba 1200, piso 3 depto B · Rosario, Santa Fe (2000)"
export const deliveryAddressLabel = (purchaseOrder) => {
    if (!purchaseOrder) return '';
    const street = [purchaseOrder.streetName, purchaseOrder.streetNumber]
        .filter(Boolean)
        .join(' ');
    const unit = [
        purchaseOrder.floor && `piso ${purchaseOrder.floor}`,
        purchaseOrder.apartment && `depto ${purchaseOrder.apartment}`,
    ]
        .filter(Boolean)
        .join(' ');
    const first = [street || purchaseOrder.address, unit]
        .filter(Boolean)
        .join(', ');
    const place = [purchaseOrder.city, purchaseOrder.province]
        .filter(Boolean)
        .join(', ');
    const second = [
        place,
        purchaseOrder.postalCode && `(${purchaseOrder.postalCode})`,
    ]
        .filter(Boolean)
        .join(' ');
    return [first, second].filter(Boolean).join(' · ');
};

// El total lo manda la API (`total`); sumar ítems queda como fallback para las
// órdenes anteriores a esa columna.
export const orderTotal = (purchaseOrder) => {
    if (
        purchaseOrder &&
        purchaseOrder.total !== null &&
        purchaseOrder.total !== undefined
    ) {
        return Number(purchaseOrder.total);
    }
    return ((purchaseOrder && purchaseOrder.items) || []).reduce(
        (total, item) => total + lineTotal(item),
        0
    );
};

export { lineTotal };
